(ns frontend.test.datepicker
  (:require
   [reagent.core :as r]
   [frontend.routing :as routing]
   [basic-components.field-editor :as field-editor]
   [basic-components.inputs.footprint :refer [editor viewer]]))

(defn sample-date
  []
  (let [state (r/atom {})]
    (fn []
      [:div
       [:h2.title-h2.mt-4 "Date"]

       [:h4.title-h3.mt-4.mb-3 "Editor mode"]
       [:div.datepicker__wrapper
        [editor
         {:editor/type :editor.type/date
          :state-atom  state
          :class-name  "datepicker"
          :value       (:value @state)
          :on-change!  (fn [e value]
                         (swap! state assoc :value value))}]]

       [:h4.title-h3.mt-4.mb-3 "Field editor mode"]
       [:div.datepicker__wrapper
        [field-editor/view
         {:editor/type         :editor.type/date
          :value               (:value @state)
          :state-atom          state
          :attribute           :test-date-attribute
          :label               "Date picker"
          :hide-label?         false
          :on-change!          (fn [_ v]
                                 (swap! state assoc :value v))
          :class-name          "datepicker"
          :theme               "zap-datepicker"
          :mandatory?          true
          :drag-options        nil
          :validate!           (fn []
                                 true)
          :disabled?           false
          :read-only?          false
          :info-text           "Info Email"
          :error-text          "Test error email"
          :tools               [:tool-item/clear
                                :tool-item/copy
                                :tool-item/save
                                :tool-item/cancel]
          :secondary-view-args nil}]]])))


(defmethod routing/render-view :test/datepicker
  [{:keys [route-params]}]
  (let [state (r/atom {})]
    (fn []
      (let []
        [:div.p-4
         [:h2.title-h2.mb-2 "Datepicker"]
         [sample-date]]))))
